var map = {
	"./332fc4f1-cbad-4485-96f3-6fdf077d36c9.png": "9aac",
	"./404.png": "16f4",
	"./4ea6aae0-793f-443c-9b38-caf924956886.png": "fee1",
	"./ToBank.png": "842a",
	"./ToFlashpay.png": "cd04",
	"./activate-result.png": "da3b",
	"./bank-image/bg-card-krungsri.png": "58a3",
	"./bank-image/bg-card-scb.png": "e583",
	"./high-icon.png": "8846",
	"./high-user.png": "63e2",
	"./hot.png": "15ea",
	"./images/face-img.png": "65c5",
	"./images/id-img-down.png": "f0c4",
	"./images/id-img-up.png": "751b",
	"./logo.png": "cf05",
	"./low-icon.png": "2ec4",
	"./no-order.png": "d514",
	"./screenshot-20230118-121548.png": "9cf0",
	"./terms-conditions.png": "4c66",
	"./uniBank.png": "9f6a",
	"./user-icon.png": "0359",
	"./verified.png": "f43f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";